"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateCollection = exports.startdeleteCollection = exports.startUpdateCollection = exports.startDeleteHotel = exports.setCollections = exports.saveTokens = exports.getCollections = exports.deleteHotel = exports.deleteCollection = exports.createCollection = exports.clearCollections = exports.addHotelToCollection = exports.addCollection = void 0;
var _reduxActions = require("redux-actions");
var _createActions = (0, _reduxActions.createActions)({
    saveTokens: function saveTokens(api, project, tf, user) {
      return {
        api: api,
        project: project,
        tf: tf,
        user: user
      };
    },
    getCollections: function getCollections() {
      return undefined;
    },
    setCollections: function setCollections(collections) {
      return collections;
    },
    clearCollections: function clearCollections() {
      return undefined;
    },
    addHotelToCollection: function addHotelToCollection(hotelID, collectionID) {
      return {
        hotelID: hotelID,
        collectionID: collectionID
      };
    },
    createCollection: function createCollection(name, isAgent, countryID, onSuccess) {
      return {
        name: name,
        isAgent: isAgent,
        countryID: countryID,
        onSuccess: onSuccess
      };
    },
    addCollection: function addCollection(key, collection) {
      return {
        key: key,
        collection: collection
      };
    },
    startdeleteCollection: function startdeleteCollection(collectionID) {
      return collectionID;
    },
    deleteCollection: function deleteCollection(key, collectionID) {
      return {
        key: key,
        collectionID: collectionID
      };
    },
    startDeleteHotel: function startDeleteHotel(collectionID, hotelID) {
      return {
        collectionID: collectionID,
        hotelID: hotelID
      };
    },
    deleteHotel: function deleteHotel(key, collectionID, hotelID) {
      return {
        key: key,
        collectionID: collectionID,
        hotelID: hotelID
      };
    },
    startUpdateCollection: function startUpdateCollection(collectionID, collection, onSuccess) {
      return {
        collection: collection,
        collectionID: collectionID,
        onSuccess: onSuccess
      };
    },
    updateCollection: function updateCollection(key, collectionID, nextCollection) {
      return {
        key: key,
        collectionID: collectionID,
        nextCollection: nextCollection
      };
    }
  }, {
    prefix: 'COLLECTIONS'
  }),
  addHotelToCollection = exports.addHotelToCollection = _createActions.addHotelToCollection,
  clearCollections = exports.clearCollections = _createActions.clearCollections,
  getCollections = exports.getCollections = _createActions.getCollections,
  saveTokens = exports.saveTokens = _createActions.saveTokens,
  setCollections = exports.setCollections = _createActions.setCollections,
  createCollection = exports.createCollection = _createActions.createCollection,
  addCollection = exports.addCollection = _createActions.addCollection,
  startdeleteCollection = exports.startdeleteCollection = _createActions.startdeleteCollection,
  deleteCollection = exports.deleteCollection = _createActions.deleteCollection,
  startDeleteHotel = exports.startDeleteHotel = _createActions.startDeleteHotel,
  deleteHotel = exports.deleteHotel = _createActions.deleteHotel,
  updateCollection = exports.updateCollection = _createActions.updateCollection,
  startUpdateCollection = exports.startUpdateCollection = _createActions.startUpdateCollection;